import { BaseTable, Card, CommandButton, HeaderMenu, Label, Loading, Select } from "components";
import { Item } from "./components";
import { appDropdown, useApprovalList } from "./utils";
import { useState } from "react";

export default function ApproveBills() {

    const [searchData, setSearchData] = useState<string>('1')
    const { data, isLoading, refetch } = useApprovalList(searchData)

    return (
        <section className="container my-2">
            <section>
                <HeaderMenu title="APPROVAL BILLS" />

                <section>
                    <section className="mt-2">
                        <Card>
                            <Card.Body>
                                <div className="justify-end lg:flex items-center">
                                    <Label className="mr-2">APPROVAL</Label>
                                    <Select
                                        className="lg:w-[200px]"
                                        placeholder="Select Approval"
                                        options={appDropdown}
                                        value={appDropdown.find(item => item.value === searchData)}
                                        onChange={e => setSearchData(e?.value ?? '')}
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                    </section>
                </section>

                <section className="mt-2">
                    <Card>
                        <Card.Body>
                            <div className="overflow-x-auto">
                                <BaseTable>
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th colSpan={2}>BILLS ID#</th>
                                            <th>DATE</th>
                                            <th>VENDOR</th>
                                            <th>REF PO ID#</th>
                                            <th>DELIVERY</th>
                                            <th>LOCATION</th>
                                            <th>MEMO</th>
                                            <th>STATUS APPROVE</th>
                                            <th>DATE APPROVE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading || data?.length === 0 ? (
                                            <tr>
                                                <td colSpan={12} className="text-center">
                                                    <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                                                </td>
                                            </tr>)  
                                            : data?.map((item, key: number) => (
                                                <Item data={item} index={key} refetch={refetch} />
                                            ))}
                                    </tbody>
                                </BaseTable>
                            </div>
                        </Card.Body>
                    </Card>
                </section>

                <section className="mt-2">
                    <Card>
                        <Card.Body className="flex flex-col gap-5">
                            <section className="flex flex-wrap justify-between items-center gap-3">
                                <section className="flex flex-wrap gap-3">
                                    <CommandButton actiontype="help" />
                                    <CommandButton actiontype="print" />
                                    <CommandButton actiontype="email" />
                                    <CommandButton actiontype="export" />
                                </section>
                            </section>
                        </Card.Body>
                    </Card>
                </section>
            </section>
        </section>
    )
}